import { TableOption, TableOptions } from 'Design/components/Table'

const BotOptions = (props) => {
  const { id, isDefaultBot, onEditBot, onDeleteBot, onSetDefaultBot, onTestBot } = props

  const handleEditClick = () => {
    onEditBot(id)
  }

  const handleTestClick = () => {
    onTestBot(id)
  }

  const handleSetDefaultBot = () => {
    onSetDefaultBot(id)
  }

  const handleDeleteBot = () => {
    onDeleteBot()
  }

  return (
    <TableOptions>
      {!isDefaultBot && <TableOption onClick={handleSetDefaultBot}>Set as Default Bot</TableOption>}
      <TableOption onClick={handleEditClick}>Edit</TableOption>
      <TableOption onClick={handleTestClick}>Test</TableOption>
      {!isDefaultBot && <TableOption onClick={handleDeleteBot}>Delete</TableOption>}
    </TableOptions>
  )
}

export default BotOptions
